import { Stack } from '@mui/material';
import React, { useContext } from 'react';
import { ArrowRight as ArrowRightIcon } from '@mui/icons-material';
import { CitationButton } from 'shared-components/components/FormFields';
import { ClinexContext } from '../Clinex/context';
import { navigateToClinexHighlight } from './helpers';

interface Props {
  field: string;
  children: React.ReactNode;
  ajccVersion?: number;
  clinexData?: any;
}

const ClinexFieldWrapper = ({ children, ajccVersion, field, clinexData: propClinexData }: Props): JSX.Element => {
  let navigateTo = field;
  const tnm_stage = field.slice(0, 7);
  const clinexContext = useContext(ClinexContext);
  const { fieldSelected, clinexData: contextClinexData, setClinexModalOpen } = clinexContext;

  // Use prop data if provided, otherwise fall back to context data
  const clinexData = propClinexData || contextClinexData;

  let fieldHasHighlight = clinexData?.[field]?.['highlight_geoms'];
  if (!fieldHasHighlight && ajccVersion) {
    const currentType = field.slice(8);
    const otherType = currentType === 'clinical' ? 'pathological' : 'clinical';
    navigateTo = field.replace(currentType, otherType);
    fieldHasHighlight = clinexData?.[navigateTo]?.['highlight_geoms'];
  }

  const showArrowRight = (fieldSelected?.slice(0, 7) === tnm_stage && ajccVersion) || fieldSelected === navigateTo;

  return (
    <Stack direction="row" alignItems="center" sx={{ width: '100%' }} data-testid={`clinex-wrapper-${field}`}>
      {children}
      <Stack direction="row" sx={{ height: '100%', marginBottom: 'auto' }}>
        {fieldHasHighlight && (
          <CitationButton
            onClick={() => {
              navigateToClinexHighlight(navigateTo, clinexContext, clinexData);
              setClinexModalOpen(true);
            }}
            data-testid="clinex-icon"
            sx={{ height: '100%' }}
          />
        )}
        {fieldHasHighlight &&
          (showArrowRight ? (
            <ArrowRightIcon
              data-testid="clinex-icon-arrow"
              sx={{ fontSize: '32px', marginLeft: '-4px', marginRight: '-6px', marginTop: '2px' }}
              color="primary"
            />
          ) : (
            <Stack sx={{ width: '22px' }} />
          ))}
      </Stack>
    </Stack>
  );
};

export default ClinexFieldWrapper;
